
export const REPORT_ACTION_CANCELLED: string = 'reportAction.cancelled';